enum IntensityEnum {
  BELOW_5 = 'BELOW_5',
  ABOVE_10 = 'ABOVE_10',
  BETWEEN_5_AND_10 = 'BETWEEN_5_AND_10'
}

export default IntensityEnum;
